import React from 'react'

import { DeliveryForecastItemSplit } from '../../../../../data/models'
import { ConfigurableTable } from '../../../../../utils/wrapper'
import { useConfigContext } from '../../../../ui-config'

type Props = {
  items: [DeliveryForecastItemSplit, ...DeliveryForecastItemSplit[]] | undefined
  isLoading: boolean
}

export const Splits: React.FC<Props> = ({ items, isLoading }) => {
  const { uiConfig: config } = useConfigContext()

  return (
    <ConfigurableTable
      dataKey="BuyerDeliveryDate"
      config={config.deliveryForecast.acceptDeliveryForecast.table}
      data={items}
      isLoading={isLoading}
      stateKey=""
    />
  )
}
